<template>
  <el-dialog title="智能识别" :visible.sync="dialogVisible" class="mx-50" top="40px">
    <p style="color: red">
        输入数据字段顺序必须为[发票代码、发票号码、购方企业名称、购方税号、银行账户、地址电话、开票日期、商品编码版本号、单据号、商品名称、规格、单位、数量、单价、金额、税率、税额、税收分类编码]
    </p>
    <label>粘贴内容</label>
    <el-input v-model="content" autoComplete="on" type="textarea" :autosize="{minRows: 4, maxRows: 6}"></el-input>
    <div style="right">
      <el-button size="small" @click="cancelData">取消</el-button>
      <el-button type="primary" size="small" @click="getContent">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { 
    createReceivable, 
    fetchSettingCompanyAccountListByBranchOfficeCode 
  } from '@/api/billing'
  import { formatDateTime } from '@/utils/misc'
  import { EventBus } from "@/utils/event-bus"

  export default {
    name: 'receivable-batch-dialog',
    props: [
      'billing_file_id',
    ],
    data() {
      return {
        dialogVisible: false,
        content: '',
        accountOptions: [],
      }
    },
    methods: {
      getAccountOptions(branch_office_code) {
        console.log('getAccountOptions: ' + branch_office_code)
        fetchSettingCompanyAccountListByBranchOfficeCode(branch_office_code)
          .then(res=>{
            console.log(res)
            this.accountOptions = res
          }).catch(err=>{
            this.$error_message(err)
          })
      },
      handleCreate(branch_office_code) {
        console.log('handleCreate batch create branch_office_code: ' + branch_office_code)
        this.getAccountOptions(branch_office_code)
        this.dialogVisible = true
      },
      cancelData() {
        this.content = ''
        this.dialogVisible = false
      },
      matchCompany(invoice_data) {
        let accountSelected = this.accountOptions.filter((account)=>{
            return (account.label === invoice_data[2] && account.value === invoice_data[3])
        })
        if (accountSelected !== null && accountSelected.length > 0){
          return true
        }
        else {
          this.$error_message('开票公司信息与账单不相符')
          return false
        }
      },
      getContent() {
        const content_list = this.content.replace(/[\n\t\r]/g, '|').split('|')

        const invoice_num = parseInt(content_list.length / 18)
        for (var i=0; i<invoice_num; i++) {
            const invoice_data = content_list.slice(18*i , 18*(i+1))

            const company_match = this.matchCompany(invoice_data)
            console.log('company_match: ', company_match)

            if (company_match) {
                const fd = new FormData()
                fd.set('billing_file', this.billing_file_id)
                fd.set('income_type', 1)
                fd.set('invoice_number', invoice_data[1])
                fd.set('insurance_company', invoice_data[2])
                fd.set('taxpayer_id', invoice_data[3])
                fd.set('vat', invoice_data[16])
                fd.set('sales', invoice_data[14])
                fd.set('invoiced_amount', (Number(invoice_data[14])+Number(invoice_data[16])).toFixed(2))
                fd.set('amount', (Number(invoice_data[14])+Number(invoice_data[16])).toFixed(2))
                fd.set('non_invoiced_amount', 0)

                let oldDate = new Date(invoice_data[6]).getTime()
                let newDate = new Date(oldDate)
                fd.set('invoiced_date', formatDateTime(newDate))

                createReceivable(fd, this.billing_file_id)
                .then(res => {
                  this.$notify({
                    message: `新增收入成功, id=${res.id}`,
                    type: 'success'
                  })
                })
                .catch(error => {
                  this.$notify({
                    message: error.message,
                    type: 'error'
                  })
                })
            }
        }
        this.cancelData()
        EventBus.$emit('created-receivable')
      }
    }
  }
</script>